import * as React from "react";

function SvgCaravanSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M15 11a.5.5 0 100 1 .5.5 0 000-1zm6.5 3.5H20v-5a5 5 0 00-5-5H4a2 2 0 00-2 2v8a2 2 0 002 2h1a3 3 0 006 0h10.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zM8 18a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm2-7.5a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h4a1 1 0 011 1v2zm6 4h-4v-6a1 1 0 011-1h2a1 1 0 011 1v6z"
        fill="currentColor"
      />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgCaravanSolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
